module.exports = __webpack_public_path__ + "static/img/wechat.c72786e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/wechat.png
// module id = ZHGz
// module chunks = 1